export default __webpack_public_path__ + "static/media/info-tooltip-2.b95b2349.svg";